import * as React from "react";
import {withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router";
import "./partnerMigration.scss";
import Routes from "../../../navigation/route/Route";
import MigrationView from "./MigrationView";

const logo = require('../../../../resources/hiber/img/dg-logo-big-green.png');

type Props = RouteComponentProps<{}>;

class PartnerMigration extends React.PureComponent<Props, {}> {
	render() {
		return (
			<div className="c-partner-migration">
				<div className="c-partner-migration_logo-container">
					<img src={logo} className="c-partner-migration_logo"/>
				</div>
				<div className="c-partner-migration_migration-views-container">
					<MigrationView proceedToApp={() => this.props.history.push(Routes.LeadsList)}/>
				</div>
			</div>
		);
	}
}

export default withRouter(PartnerMigration);
